import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgAnxiousSelectedEmoji(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.452 3.784 20.425 3l2.265 2.81-.973.785-2.265-2.81Zm6.365 2.03 2.267-2.81.973.786-2.268 2.808-.972-.785ZM24.25 28.752c1.055 0 1.91-.466 1.91-1.04 0-.575-.855-1.04-1.91-1.04s-1.91.465-1.91 1.04c0 .574.855 1.04 1.91 1.04ZM8 24.004c0-8.838 7.16-15.997 16-15.997s16 7.159 16 15.997c0 8.838-7.16 15.997-16 15.997S8 32.842 8 24.004Zm8.35-7.168-3.55 2.21.66 1.059 3.55-2.21-.66-1.06Zm-.66 6.128c0 .65.53 1.18 1.18 1.18.66 0 1.18-.53 1.18-1.18 0-.65-.53-1.18-1.18-1.18-.65 0-1.18.53-1.18 1.18Zm5.65 4.75c0 1.14 1.28 2.039 2.91 2.039 1.63 0 2.91-.9 2.91-2.04 0-1.14-1.28-2.04-2.91-2.04-1.63 0-2.91.9-2.91 2.04Zm8.84-4.75c0 .65.53 1.18 1.18 1.18.65 0 1.18-.53 1.18-1.18 0-.65-.53-1.18-1.18-1.18-.65 0-1.18.53-1.18 1.18Zm.08-5.069 3.55 2.21.66-1.06-3.55-2.21-.66 1.06Z",
    fill: "currentColor"
  }));
}

export { SvgAnxiousSelectedEmoji as default };
